import { encodePeriodValue } from '@components'

import { ReactElement, useCallback, useEffect, useRef } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useGlobalFiscalYear } from '../../../../../../contexts/globalFiscalYearContext'
import { PeriodMode } from '../../../../../../enums/periodMode'
import type { PeriodValue } from '../../../../../../types/periodValue'
import { getPeriodValueFromFiscalYear } from '../../../../../../utils/getPeriodValueFromFiscalYear'
import { useSalesReportFilters } from '../../../../hooks/useSalesReportFilters'
import { SalesReportPeriodPicker } from './elements/SalesReportPeriodPicker'

export const SalesReportPeriodSelect = (): ReactElement | null => {
  const { organization } = useUserOrganization()
  const [{ period: queryParamPeriod }, setQueryParams] = useSalesReportFilters()
  const { fiscalYear: globalFiscalYear, setFiscalYear } = useGlobalFiscalYear()
  const hasPeriodBeenSetRef = useRef(false)

  useEffect(() => {
    const shouldSetInitialPeriod =
      !!organization?.id && !queryParamPeriod && globalFiscalYear !== undefined && !hasPeriodBeenSetRef.current

    if (shouldSetInitialPeriod) {
      hasPeriodBeenSetRef.current = true

      const periodValue = getPeriodValueFromFiscalYear(globalFiscalYear)

      setQueryParams({ period: encodePeriodValue(periodValue, organization.id) })
    }
  }, [globalFiscalYear, organization, queryParamPeriod, setQueryParams])

  const handlePeriodChange = useCallback(
    (periodValue: PeriodValue) => {
      if (!organization?.id) {
        return
      }

      setQueryParams({ period: encodePeriodValue(periodValue, organization.id) })

      if (periodValue.mode === PeriodMode.FiscalYear && periodValue.value !== undefined) {
        setFiscalYear(periodValue.value)
      }
    },
    [organization, setFiscalYear, setQueryParams],
  )

  return queryParamPeriod ? (
    <SalesReportPeriodPicker encodedPeriod={queryParamPeriod} onChange={handlePeriodChange} />
  ) : null
}
